import React, { FC, PropsWithChildren } from 'react';
import { Intl } from '@erecruit/core';
import { FlexItem, styled, Tooltip, H4, Icon, Flex } from '@erecruit/ui-kit';

const { FormattedMessage } = Intl;

interface EmptySelectionWarningProps {
  display: boolean;
  messageId: Intl.LocalizationKeysArray;
}

const EmptySelectionWarning: FC<EmptySelectionWarningProps> = props => {
  const { display, messageId } = props;

  return display ? (
    <Tooltip
      overlay={
        <H4 weight={400}>
          <FormattedMessage id={messageId} />
        </H4>
      }
      placement="top"
    >
      <Icon type="info" size="small" />
    </Tooltip>
  ) : null;
};

const InfoPlaceholder = styled.div({
  display: 'flex',
  width: 30,
  flexGrow: 0,
  justifyContent: 'center',
  alignItems: 'center',
});

interface InfoContainerProps {
  messageId: Intl.LocalizationKeysArray;
  displayInfo: boolean;
}

const InfoContainer: FC<PropsWithChildren<InfoContainerProps>> = props => {
  return (
    <Flex>
      <FlexItem>{props.children}</FlexItem>
      <InfoPlaceholder>
        <EmptySelectionWarning
          messageId={props.messageId}
          display={props.displayInfo}
        />
      </InfoPlaceholder>
    </Flex>
  );
};

export default InfoContainer;
